import React, { useState } from 'react';
import { updateCrmLeadStage } from '../config/api';

const OPTIONS = [
  { value: 'contacted', label: 'Contacted' },
  { value: 'interested', label: 'Interested' },
];

const CrmStageDialog = ({ lead, onClose, onSaved }) => {
  const initialStage = OPTIONS.some((option) => option.value === lead.stage)
    ? lead.stage
    : '';
  const [stage, setStage] = useState(initialStage);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  const save = async (event) => {
    event.preventDefault();
    if (!stage || saving) return;
    setSaving(true);
    setError('');
    try {
      const response = await updateCrmLeadStage(lead.id, stage);
      const result = response?.data || response;
      if (onSaved) onSaved(result);
    } catch (err) {
      setError(err.message || 'Could not update the Lead stage.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={saving ? undefined : onClose}>
      <form className="modal-content" onSubmit={save}
        onClick={(event) => event.stopPropagation()} style={{ maxWidth: '480px' }}>
        <div className="modal-header">
          <div>
            <h3>Update Lead stage</h3>
            <div className="crm-modal-subtitle">
              Record the current outcome for {lead.displayName || `Lead #${lead.id}`}.
            </div>
          </div>
          <button type="button" className="modal-close" onClick={onClose} disabled={saving}>×</button>
        </div>
        <div className="modal-body">
          <label className="form-label" htmlFor="crm-manual-stage">Stage</label>
          <select id="crm-manual-stage" className="form-control" value={stage}
            onChange={(event) => { setStage(event.target.value); setError(''); }} disabled={saving}>
            <option value="">Select stage</option>
            {OPTIONS.map((option) => (
              <option key={option.value} value={option.value}>{option.label}</option>
            ))}
          </select>
          <div className="crm-muted" style={{ marginTop: '8px' }}>
            Order activity continues to control Active and Inactive stages.
          </div>
          {error && <div className="crm-form-error">{error}</div>}
        </div>
        <div className="modal-footer">
          <button type="button" className="btn btn-secondary" onClick={onClose} disabled={saving}>Cancel</button>
          <button type="submit" className="btn btn-primary" disabled={!stage || saving}>
            {saving ? 'Saving…' : 'Save stage'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default CrmStageDialog;
